module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAc0lEQVRYhe2XsQ2AMAwEfxSPkI29BHuloQcLGZQCOuIH6S1dk+bPrvJAzrrAAg96sE2iZ4ZhnHhok4PvRNq4eWX4KGHIk1SHnzhI219XADH8QAKPAm+PBCQgAQlIQAL/E6hCAhL4xLfciQLOr2b0csqu5ztAeOOWWyMtRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons/slide.png
// module id = 1620
// module chunks = 0